import React from "react";

import StoreLocatorMobile from "./storeLocatorMobile.component";

export type StoreLocatorMobileContainerProps = {
    link: string;
};

const StoreLocatorMobileContainer = ({ link }: StoreLocatorMobileContainerProps) => (
    <StoreLocatorMobile link={link} />
);

export { StoreLocatorMobileContainer };
